import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';

import { Plan } from './plan';
import { AgeFactor } from './age-factor';
import { AreaRateFactor } from './area-rate-factor';
import { PlanServiceArea } from './plan-service-area';
import { Locality } from './locality';
import { PlanLocality } from './plan-locality';

import { GlobalsService } from './globals.service';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};



@Injectable({ providedIn: 'root' })
export class PlansApiService {

  private server = this.globalsService.getServer();
  
  private plansUrl = this.server + '/api/Plans?filter[where][and][0][metal][neq]=Catastrophic';
  private ageFactorsUrl = this.server + '/api/AgeFactors';
  private areaRateFactorsUrl = this.server + '/api/GeographicFactors';
  private planServiceAreasUrl = this.server + '/api/PlanServiceAreas';
  //private localitiesUrl = this.server + '/api/ServiceAreas?filter[where][ratingarea]=2';
  private localitiesUrl = this.server + '/api/ServiceAreas';
  private planLocalitiesUrl = this.server + '/api/PlanLocalities';

  constructor(
    private http: HttpClient,
    public globalsService: GlobalsService
  ) {

  }

  /** GET plans from the server */
  getPlans (): Observable<Plan[]> {
    return this.http.get<Plan[]>(this.plansUrl)
      .pipe(
        //tap(heroes => this.log(`fetched heroes`)),
        catchError(this.handleError('getplans', []))
      );
  }

  /** GET plan by id. Return `undefined` when id not found */
  getPlanNo404<Data>(id: string): Observable<Plan> {
    const url = `${this.plansUrl}/?id=${id}`;
    return this.http.get<Plan[]>(url)
      .pipe(
        map(plans => plans[0]), // returns a {0|1} element array
        tap(h => {
          const outcome = h ? `fetched` : `did not find`;
          //this.log(`${outcome} hero id=${id}`);
        }),
        catchError(this.handleError<Plan>(`getHero id=${id}`))
      );
  }

  /** GET plan by id. Will 404 if id not found */
  getPlan(id: number): Observable<Plan> {
    const url = `${this.plansUrl}/${id}`;
    return this.http.get<Plan>(url).pipe(
      //tap(_ => this.log(`fetched hero id=${id}`)),
      catchError(this.handleError<Plan>(`getPlan id=${id}`))
    );
  }

  /** GET age factors from the server */
  getAgeFactors (): Observable<AgeFactor[]> {
    return this.http.get<AgeFactor[]>(this.ageFactorsUrl)
      .pipe(
        //tap(heroes => this.log(`fetched heroes`)),
        catchError(this.handleError('getAgeFactors', []))
      );
  }

  /** GET area rate factors from the server */
  getAreaRateFactors (): Observable<AreaRateFactor[]> {
    return this.http.get<AreaRateFactor[]>(this.areaRateFactorsUrl)
      .pipe(
        //tap(heroes => this.log(`fetched heroes`)),
        catchError(this.handleError('getAreaRateFactors', []))
      );
  }

  /** GET plan service areas from the server */
  getPlanServiceAreas (): Observable<PlanServiceArea[]> {
    return this.http.get<PlanServiceArea[]>(this.planServiceAreasUrl)
      .pipe(
        //tap(heroes => this.log(`fetched heroes`)),
        catchError(this.handleError('getPlanServiceAreas', []))
      );
  }

  /** GET localities from the server */
  getLocalities (): Observable<Locality[]> {
    return this.http.get<Locality[]>(this.localitiesUrl)
      .pipe(
        //tap(heroes => this.log(`fetched heroes`)),
        catchError(this.handleError('getLocalities', []))
      );
  }

  /** GET plan localities from the server */
  getPlanLocalities (): Observable<PlanLocality[]> {
    return this.http.get<PlanLocality[]>(this.planLocalitiesUrl)
      .pipe(
        //tap(heroes => this.log(`fetched heroes`)),
        catchError(this.handleError('getPlanLocalities', []))
      );
  }

  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  private handleError<T> (operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      //this.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}